
import { HttpResponse } from "../auth/AuthInterface";

// Definición de defaults

export const defaultDetalleListadoEntregaResponse: DetalleListadoEntregaResponse = {
    idListadoEntrega: 0,
    idEstatus: 0,
    asignadoMismoUsuario: false,
    documento: ''
}

export const defaultBuscarListadoEntregaResponse: BuscarListadoEntregaResponse = {
    recordsCount: 0,
    currentPageIndex: 0,
    pageCount: 0,
    listadosEntrega: [],
}

// Creación de interfaces

export interface NuevoListadoEntregaResponse extends HttpResponse {
    idListadoEntrega: string;
}

export interface ListadoEntregaRecepcionProps {
    idRecepcion:            number;
    idRecepcionJuzgado:     number;
    numeroSeguimiento:      string;
    referencia:             string;
    noReferencia:           string;
    tipoTramite:            string;
    subTipoTramite:         string;
    idEstatus:              number;
    estatus:                string;
    folioBuzonElectronico:  string;
    acuse:                  string;
    escrito:                string
    materia:                string;
    selected:               boolean;
    fecha?:                 Date;
}

export interface DetalleListadoEntregaResponse {
    idListadoEntrega:       number;
    documento:              string;
    idEstatus:              number;
    asignadoMismoUsuario:   boolean;
    fecha?:                 Date;
}

export interface DetalleListadoEntregaTablaParams {
    idListadoEntrega:   string;
    fecha:              string;
    idTipoTramite:      number;
    idMateria:          number;
    enviadoBuzon:       number;
}

export interface GenerarListadoEntregaParams {
    idListadoEntrega:       string;
    recepciones:            ListadoEntregaRecepcionProps[];
}

export interface GenerarDocumentoListadoEntregaResponse extends HttpResponse {
    documento: string;
}

export interface BuscarListadoEntregaParams {
    fechaInicio:                string;
    fechaFin:                   string;
    page:                       number;
    rowsPerPage:                number;
}

export interface BuscarListadoEntregaResponse {
    currentPageIndex:       number;
    pageCount:              number;
    recordsCount:           number;
    listadosEntrega:        ListadoEntregaProps[];
}

export interface ListadoEntregaProps {
    idListadoEntrega:       number;
    usuarioGenero:          string;
    documento:              string;
    recepcion:              ListadoEntregaRecepcionProps[];
    fecha?:                 Date;
}
